import type { KioskPrinterConfig } from '@/kiosk-core';
import { createBackendEntrDataTransport } from './backendEntrDataTransport';
import { createKioskPaymentTransport } from './kioskPaymentTransport';
import { createKioskPrintTransport } from './kioskPrintTransport';
import { createMockEntrDataTransport } from './mockEntrDataTransport';
import { createMockPaymentTransport } from './mockPaymentTransport';
import { createMockPrintTransport } from './mockPrintTransport';
import { entrScanner } from './scanner';
import type { EntrRuntime } from './types';

export interface EntrRuntimeOptions {
  resolvePrinterId?: () => string | null | undefined;
  resolvePrinterConfig?: () => KioskPrinterConfig | null | undefined;
  resolvePaymentDestination?: () => string | null | undefined;
  resolveStripeAccountId?: () => string | null | undefined;
}

export function createEntrRuntime(
  options: EntrRuntimeOptions = {}
): EntrRuntime {
  const mockData = createMockEntrDataTransport();

  return {
    data:
      import.meta.env.VITE_ENTR_TRANSPORT === 'backend'
        ? createBackendEntrDataTransport({ fallback: mockData })
        : mockData,
    payment:
      import.meta.env.VITE_ENTR_PAYMENT_TRANSPORT === 'kiosk'
        ? createKioskPaymentTransport({
            resolvePaymentDestination: options.resolvePaymentDestination,
            resolveStripeAccountId: options.resolveStripeAccountId,
          })
        : createMockPaymentTransport(),
    print:
      import.meta.env.VITE_ENTR_PRINT_TRANSPORT === 'kiosk'
        ? createKioskPrintTransport({
            resolvePrinterId: options.resolvePrinterId,
            resolvePrinterConfig: options.resolvePrinterConfig,
          })
        : createMockPrintTransport(),
    scanner: entrScanner,
  };
}
